import React from "react";

const SetRole = () => {
  return (
    <body className=" p-6">
      <div className="space-y-8 bg-white p-6 rounded-lg h-screen">
        <div>
          <div className="flex items-center space-x-2">
            <span className="font-semibold text-[27.24px]">Dashboard</span>
            <label className="switch">
              <input type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>
          <div className="flex flex-wrap space-x-4 mt-2">
            <div className="flex items-center space-x-2">
              <div className="border text-[19.07px] rounded px-4 py-3 w-fit flex items-center gap-2">
                <span>Edit</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-6 w-6 checked:bg-green-500 "
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>View</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center space-x-2">
            <span className="font-semibold text-[27.24px]">Staff</span>
            <label className="switch">
              <input type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>
          <div className="flex flex-wrap space-x-4 mt-2">
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Staff List</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Role Permission</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Edit Staff</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Edit Staff</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Edit Staff</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center space-x-2">
            <span className="font-semibold text-[27.24px]">Bookings</span>
            <label className="switch">
              <input type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>
          <div className="flex flex-wrap space-x-4 mt-2">
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Add Booking</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Edit Booking</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Delete Booking</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center space-x-2">
            <span className="font-semibold text-[27.24px]">Check In</span>
            <label className="switch">
              <input type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>
          <div className="flex flex-wrap space-x-4 mt-2">
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Add Check in</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Edit Check in</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Delete Check in</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center space-x-2">
            <span className="font-semibold text-[27.24px]">Expense</span>
            <label className="switch">
              <input type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>
          <div className="flex flex-wrap space-x-4 mt-2">
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Add</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Edit Check in</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="border rounded px-4 py-2 w-fit flex items-center gap-2">
                <span>Delete Check in</span>
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-green-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>
  );
};

export default SetRole;
